import React, { Component } from "react";
import { connect } from "react-redux";
import { DIMENSIONS } from "services/layoutManager";
import BloxPage from "sub_components/Layout/BloxPage";
import ComponentWrapper from "sub_components/Layout/ComponentWrapper";
import { RESOLUTIONS } from "services/config";
import { MENU } from "utils/BillingConstants";
import { BillingApi } from "services/billing";
import { SITE_PAGES, SITE_MODULES } from "utils/CommonConstants";
import {
  updatePage,
  updateModule,
  addPageToBreadCrumbs,
} from "actions/siteTracking";
import { CardScrollerVertical } from "styled_components/Common/CardScrollerVertical";
import { Permissions } from "services/permissions";
import { updatePermissions } from "actions/permissions";
import { getUserPermissions, setUserPermissions } from "services/user";
import { BillingDetails } from "styled_components/Billing/BillingDetails";
// import { InvoiceDetail } from "styled_components/Billing/InvoiceDetail";
import { BillingTransactions } from "styled_components/Billing/BillingTransactions";
const CDN_URL = process.env.REACT_APP_CDN_URL;
const dueIcon = `${CDN_URL}billing/due-icon.svg`;
const overdueIcon = `${CDN_URL}billing/icon_Invoice_pastdue.svg`;
const paidIcon = `${CDN_URL}billing/invoice-icon-paid.svg`;

const LAYOUT_CONFIG = {
  [RESOLUTIONS.LOW]: {
    invoiceDetail: { x: 0, y: 0, dim: DIMENSIONS.TWO_BY_FOUR },
    transactions: { x: 5, y: 0, dim: DIMENSIONS.TWO_BY_SIX },
    details: { x: 0, y: 19, dim: DIMENSIONS.FOUR_BY_EIGHT },
    invoices: { x: 12, y: 0, dim: DIMENSIONS.TWO_BY_TWO },
  },
  [RESOLUTIONS.MED]: {
    invoiceDetail: { x: 0, y: 0, dim: DIMENSIONS.TWO_BY_FOUR },
    transactions: { x: 5, y: 0, dim: DIMENSIONS.TWO_BY_SIX },
    details: { x: 0, y: 29, dim: DIMENSIONS.FOUR_BY_EIGHT },
    invoices: { x: 12, y: 0, dim: DIMENSIONS.TWO_BY_TWO },
  },
  [RESOLUTIONS.HIGH]: {
    invoiceDetail: { x: 0, y: 0, dim: DIMENSIONS.TWO_BY_FOUR },
    transactions: { x: 5, y: 0, dim: DIMENSIONS.TWO_BY_SIX },
    details: { x: 0, y: 50, dim: DIMENSIONS.FOUR_BY_EIGHT },
    invoices: { x: 12, y: 0, dim: DIMENSIONS.TWO_BY_TWO },
  },
};

class InvoiceDetailPage extends Component {
  constructor(props) {
    super(props);
    this.billingApi = new BillingApi();
    this.state = {
      pages: null,
      loading: true,
      invoice: null,
      selected: null,
      transactionsLoading: true,
      transactions: null,
    };
  }
  componentDidMount() {
    const {
      updatePage,
      updateModule,
      addPageToBreadCrumbs,
      company_info: { customer: { id } } = {},
      site,
      permissions,
      location,
      invoices,
      requestInvoices,
    } = this.props;
    updatePage(SITE_PAGES.BILLING[MENU.INVOICE_DETAIL]);
    addPageToBreadCrumbs(
      SITE_PAGES.BILLING[MENU.INVOICE_DETAIL],
      SITE_MODULES.BILLING
    );
    if (site?.module !== "BILLING" || !permissions?.permissions) {
      this.getModulePages();
    }

    updateModule(SITE_MODULES.BILLING);
    const invoice = location?.state?.invoice;
    if (invoice) {
      this.setState({
        invoice,
      });
      if (invoice?.transactions && invoice.transactions.length > 0) {
        this.setState({
          transactionsLoading: false,
          transactions: this.formatTransactions(invoice.transactions),
        });
      } else {
        this.getInvoiceTransactions(invoice?.soRecordNo);
      }
    } else {
      const { pathname } = window.location;
      const matches = pathname.split("/");
      if (matches) {
        const [, , , , invoiceId] = matches;
        this.setSelected(invoiceId);
      }
    }
    if (!invoices || invoices.length === 0) {
      requestInvoices(id);
    }
  }
  componentDidUpdate(prevProps) {
    const previousCompanyId = prevProps?.company_info?.customer?.id;
    const { company_info: { customer: { id } } = {}, invoices } = this.props;
    const { pathname } = window.location;
    const matches = pathname.split("/");

    if (previousCompanyId !== id) {
      this.requestInvoices(id);
    }

    if (prevProps.invoices !== invoices) {
      if (matches) {
        const [, , , , invoiceId] = matches;
        this.setSelected(invoiceId);
      }
    }
  }

  formatTransactions = (transactions) => {
    return transactions.map((transaction) => ({
      total: String(transaction.amount).includes("$") ? String(transaction.amount).replace("$", "") : transaction.amount ,
      itemDescription: transaction.description,
      created: transaction.effectiveDate,
      recordNo: transaction.invoiceNumber,
    }));
  };

  getModulePages = async () => {
    const {
      updatePermissions,
      auth_status: {
        user: { id: userId },
      },
      company_info: {
        customer: { id: orgId },
      },
    } = this.props;

    const permissions = getUserPermissions("billing");
    if (!permissions) {
      const response = await Permissions.getModulePermissions(4, userId, orgId);
      if (response && !response.data.error) {
        setUserPermissions("billing", response.data.pages);
        updatePermissions(response.data.pages);
      }
    } else {
      updatePermissions(permissions);
    }
  };

  getInvoiceTransactions = (invoiceNumber) => {
    const { company_info: { customer: { id } } = {} } = this.props;
    this.billingApi
      .getInvoiceTransactions(id, invoiceNumber)
      .then((response) => {
        this.setState({
          transactionsLoading: false,
          transactions: response?.data,
        });
      })
      .catch((error) => {
        this.setState({ transactionsLoading: false });
        console.log(error);
      });
  };

  checkViewPermissions = (data) => {
    const { permissions: pages } = this.props;
    let viewableInvoices = data;
    const ViewUnpaidInvoices = Permissions.checkComponentAccess(
      pages,
      "Invoice History",
      "view-invoices-unpaid"
    );
    const ViewPaidInvoices = Permissions.checkComponentAccess(
      pages,
      "Invoice History",
      "view-invoices-paid"
    );
    viewableInvoices = ViewPaidInvoices
      ? viewableInvoices
      : viewableInvoices.filter(
          (invoice) => invoice.status.toLowerCase() !== "paid"
        );
    viewableInvoices = ViewUnpaidInvoices
      ? viewableInvoices
      : viewableInvoices.filter(
          (invoice) =>
            invoice.status.toLowerCase() !== "due" &&
            invoice.status.toLowerCase() !== "overdue"
        );

    return viewableInvoices;
  };

  downloadPdf = (invoiceId, type, invoiceDocID) => {
    const { company_info: { customer: { id } } = {} } = this.props;
    const invoiceID = type === "intacct" ? invoiceDocID : invoiceId;
    this.billingApi
      .get(invoiceID, id, type)
      .then((response) => {
        this.setState({ pdfFile: response.data.file });

        this.billingApi.downloadPdf(response.data.file, invoiceId);
      })
      .catch((error) => this.setState({ error }));
  };
  getInvoiceIcon = (status) => {
    switch (status.toLowerCase()) {
      case "paid":
        return paidIcon;
      case "due":
        return dueIcon;
      case "overdue":
        return overdueIcon;
      default:
        return dueIcon;
    }
  };
  formatData = (invoices) => {
    return (
      invoices &&
      invoices.map((invoice) => ({
        id: invoice.invoiceId,
        name: invoice.dueDate,
        iconColor: "#dfe1e1",
        deleted: false,
        pending: false,
        mainIcon: this.getInvoiceIcon(invoice?.status),
      }))
    );
  };

  getSize = (breakpoint) => {
    let size = "large";
    if (breakpoint === RESOLUTIONS.MED) {
      size = "large";
    } else if (breakpoint === RESOLUTIONS.HIGH) {
      size = "large";
    }

    return size;
  };

  getTransactionType = (type) => {
    let transactionType = null;
    const typeLower = type ? type.toLowerCase() : "";

    if (
      typeLower === "payment" ||
      typeLower === "credit" ||
      typeLower === "credit card" ||
      typeLower === "deffered discount" ||
      typeLower === "reverse charge" ||
      typeLower === "reverse charge earned" ||
      typeLower === "write off"
    ) {
      transactionType = "debit";
    } else if (typeLower === "charge" || typeLower === "purchase") {
      transactionType = "credit";
    }

    return transactionType;
  };

  goToInvoiceHistory = () => {
    const { navigate } = this.props;
    navigate("/portal/billing/invoice_history");
  };

  setSelected = (id) => {
    const { invoices, navigate } = this.props;

    const invoice = invoices.find(
      (invoice) => Number(invoice.invoiceId) === Number(id)
    );
    this.setState({ invoice });

    if (invoice?.transactions && invoice.transactions.length > 0) {
      this.setState({
        transactionsLoading: false,
        transactions: this.formatTransactions(invoice.transactions),
      });
    } else {
      this.setState({ transactionsLoading: true, transactions: null });
      this.getInvoiceTransactions(invoice?.soRecordNo);
    }
    navigate(`/portal/billing/invoice_history/${id}`, { invoice });
  };

  render() {
    const { invoice, transactions, transactionsLoading } = this.state;
    const {
      breakpoint,
      location,
      downloadPdf,
      viewInvoice,
      invoices,
      invoicesLoading,
    } = this.props;

    return (
      <BloxPage
        name="page invoice-detail-page"
        layout={LAYOUT_CONFIG[breakpoint]}
        breakpoint={breakpoint}
        location={location}
      >
        <div key={`invoiceDetail`} className="invoiceDetail">
          <ComponentWrapper
            title={`Invoice - ${invoice?.invoice_number}`}
            hideBorder
          >
            <BillingDetails
              goToInvoiceHistory={this.goToInvoiceHistory}
              invoice={invoice}
            />
          </ComponentWrapper>
        </div>
        <div key={`transactions`} className="transactions">
          {/* <ComponentWrapper hideTitle hideBorder>
            <InvoiceDetail invoice={invoice} customer={customer} />
          </ComponentWrapper> */}
        </div>
        <div key={`details`} className="details">
          <ComponentWrapper title="Transactions" hideBorder>
            <BillingTransactions
              downloadPdf={downloadPdf}
              viewInvoice={viewInvoice}
              transactions={transactions}
              loading={transactionsLoading}
              invoice={invoice}
            />
          </ComponentWrapper>
        </div>
        <div key={`invoices`} className="invoices">
          <ComponentWrapper title="My Invoices" hideBorder>
            <CardScrollerVertical
              type="invoice"
              data={this.formatData(invoices)}
              onClick={this.setSelected}
              selected={invoice?.invoiceId}
              showButton={false}
              module="billing"
              loading={invoicesLoading}
            />
          </ComponentWrapper>
        </div>
      </BloxPage>
    );
  }
}

function mapStateToProps(state) {
  return {
    auth_status: state.auth_status,
    company_info: state.company_info,
    site: state.site_tracking,
    permissions: state.permissions,
  };
}
export default connect(mapStateToProps, {
  updatePage,
  updateModule,
  addPageToBreadCrumbs,
  updatePermissions,
})(InvoiceDetailPage);
